var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccPharmacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pharmacy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8467",
    "data-name": "Rectangle 8467",
    width: 28,
    height: 28,
    transform: "translate(390 2363)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8471",
    "data-name": "Rectangle 8471",
    width: 22.581,
    height: 22.978,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6711",
    "data-name": "Mask Group 6711",
    transform: "translate(-390 -2363)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35412",
    "data-name": "Group 35412",
    transform: "translate(392.709 2365.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35411",
    "data-name": "Group 35411",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M-2244.677,2529.231H-2260.5a1.214,1.214,0,0,1-1.212-1.213v-10.529h18.356v10.417A1.326,1.326,0,0,1-2244.677,2529.231Zm-11.257-7.287a.567.567,0,0,0-.567.566v1.7a.567.567,0,0,0,.567.566h1.987v1.988a.567.567,0,0,0,.566.566h1.7a.567.567,0,0,0,.566-.566v-1.988h1.988a.567.567,0,0,0,.566-.566v-1.7a.567.567,0,0,0-.566-.566h-1.988v-1.987a.567.567,0,0,0-.566-.567h-1.7a.567.567,0,0,0-.566.567v1.987Z",
    transform: "translate(2263.992 -2506.253)",
    fill: "#b1b4c4",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35944",
    "data-name": "Path 35944",
    d: "M5.137.994C5.137.445,4.374,0,3.433,0,2.568,0,1.86.38,1.753.867H1.744L.018,8.512H.027A.729.729,0,0,0,0,8.673C0,9.329.894,9.86,2,9.86c1.041,0,1.886-.474,1.978-1.078h.005q.574-3.844,1.146-7.69H5.12a.518.518,0,0,0,.017-.1",
    transform: "translate(0 0)",
    fill: "#b1b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35945",
    "data-name": "Path 35945",
    d: "M9.354,0c-.941,0-1.7.444-1.7.992L6.9,8.638c0,.656.894,1.186,2,1.186s2-.531,2-1.186L11.057.992c0-.547-.763-.992-1.7-.992",
    transform: "translate(-0.618 0)",
    fill: "#b1b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35946",
    "data-name": "Path 35946",
    d: "M16.83,1.012c0-.548-.762-.992-1.7-.992s-1.7.443-1.7.992l.217,7.645c0,.656.894,1.187,2,1.187s2-.532,2-1.187Z",
    transform: "translate(-1.202 -0.002)",
    fill: "#b1b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35947",
    "data-name": "Path 35947",
    d: "M24.227,8.348,22.526.992c0-.548-.762-.992-1.7-.992s-1.7.444-1.7.992L20.3,8.629v.009a.723.723,0,0,0,.033.2l.005.035h0a2.008,2.008,0,0,0,1.958.956c1.1,0,2-.532,2-1.187a.732.732,0,0,0-.067-.29",
    transform: "translate(-1.712 0)",
    fill: "#b1b4c4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccPharmacy);
export default __webpack_public_path__ + "static/media/mcc_pharmacy.2de42662df03e082bc6a681ec49761e3.svg";
export { ForwardRef as ReactComponent };